"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var StackingComponent_1 = require("../utils/StackingComponent");
var CloseButtonWidget_1 = require("./Button/CloseButtonWidget");
var TextLinkWidget_1 = require("./TextLinkWidget");
var ToastType;
(function (ToastType) {
    ToastType["Error"] = "error";
    ToastType["Warning"] = "warning";
    ToastType["Success"] = "success";
    ToastType["Info"] = "info";
})(ToastType = exports.ToastType || (exports.ToastType = {}));
var toastBackgroundColors = (_a = {},
    _a[ToastType.Error] = {
        backgroundColor: 'rgb(248,199,203)',
    },
    _a[ToastType.Warning] = {
        backgroundColor: 'rgb(255,214,187)',
    },
    _a[ToastType.Info] = {
        backgroundColor: 'rgb(215,236,249)',
    },
    _a[ToastType.Success] = {
        backgroundColor: 'rgb(172,229,200)',
    },
    _a);
exports.ToastHeight = 42;
exports.ToastMaxWidth = 800;
exports.ToastSpacing = 8;
var FontSize = TabStyles_1.TabStyles.Typography.Sizing.Default;
var LineHeight = 1.5 * FontSize;
var toastStyles = {
    positioningDiv: {
        display: 'flex',
        justifyContent: 'center',
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        visibility: 'hidden',
    },
    toastDiv: {
        alignItems: 'flex-start',
        boxShadow: TabStyles_1.TabStyles.Shadow.Standard,
        boxSizing: 'border-box',
        color: '#333',
        display: 'flex',
        flexDirection: 'row',
        fontSize: FontSize,
        minHeight: exports.ToastHeight,
        justifyContent: 'flex-start',
        padding: exports.ToastSpacing * 1.5 + "px " + exports.ToastSpacing * 3 + "px",
        position: 'relative',
        transitionProperty: 'transform, opacity',
        visibility: 'visible',
    },
    contentDiv: {
        display: 'flex',
        lineHeight: LineHeight + "px",
    },
    messageContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: -exports.ToastSpacing,
    },
    message: {
        margin: "0 " + exports.ToastSpacing + "px",
        marginBottom: exports.ToastSpacing,
    },
    actionContainer: {
        marginBottom: exports.ToastSpacing,
    },
    actionLink: {
        marginLeft: exports.ToastSpacing - 1,
    },
    closeButton: {
        cursor: 'pointer',
        margin: 0,
        marginLeft: exports.ToastSpacing * 2,
        minHeight: LineHeight,
        minWidth: LineHeight,
    },
};
var actionLinkStyleOverrideClass = TypeStyle.style({
    $nest: {
        '&&': {
            color: '#333',
            $nest: {
                '&:hover': {
                    color: '#333',
                },
                '&:active': {
                    color: '#000',
                },
            },
        },
    },
});
function prefixForToastType(toastType) {
    // tslint:disable-next-line:no-any
    return React.createElement("b", null, Localize_1.Messages[toastType + 'ToastPrefix']());
}
var ToastWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ToastWidget, _super);
    function ToastWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.autoDismissTimerId = -1;
        _this.fadeOutTimerId = -1;
        _this.isFading = false;
        _this.dismissTimerElapsed = false;
        _this.handleClick = function (e) {
            e.preventDefault();
            if (_this.props.onAction) {
                _this.props.onAction();
            }
        };
        _this.renderCloseButton = function () {
            return React.createElement(CloseButtonWidget_1.CloseButtonWidget, { className: 'prominent', "data-tb-test-id": 'toast-close-Button', onClick: _this.fadeOut, style: toastStyles.closeButton, testId: null });
        };
        _this.handleTimerElapsed = function () {
            _this.dismissTimerElapsed = true;
            _this.fadeOut();
        };
        _this.fadeOut = function () {
            var fadeTime = _this.shouldAutoDismiss() && _this.dismissTimerElapsed ? ToastWidget.AutodimissCloseFadeTransitionTimeMS
                : ToastWidget.FadeTransitionTimeMS;
            _this.setState({
                yPosition: -exports.ToastHeight,
                fadeOpacity: 0,
                fadeTransitionTime: fadeTime,
            });
            _this.isFading = true;
            _this.fadeOutTimerId = window.setTimeout(_this.onClose, fadeTime);
        };
        _this.handleMouseOver = function () {
            if (_this.shouldAutoDismiss() && !_this.isFading) {
                _this.dismissTimerElapsed = false;
                _this.setState({ fadeOpacity: 1, fadeTransitionTime: ToastWidget.HoverRestoreFadeTransitionTimeMS });
                _this.clearTimeouts();
            }
        };
        _this.handleMouseOut = function () {
            if (_this.shouldAutoDismiss() && !_this.isFading && _this.state.fadeOpacity === 1) {
                _this.autoDismissTimerId = window.setTimeout(_this.handleTimerElapsed, _this.props.autoDismissTimeMS);
            }
        };
        _this.onClose = function () {
            _this.isFading = false;
            _this.dismissTimerElapsed = false;
            _this.clearTimeouts();
            _this.props.onCloseRequest();
        };
        _this.state = {
            fadeOpacity: 0,
            fadeTransitionTime: ToastWidget.FadeTransitionTimeMS,
            yPosition: -exports.ToastHeight,
        };
        return _this;
    }
    ToastWidget.prototype.componentDidMount = function () {
        var _this = this;
        // timeout is necessary to make sure that DOM has been updated with opacity 0 from initial state.
        setTimeout(function () {
            _this.setState({
                fadeOpacity: 1,
                fadeTransitionTime: ToastWidget.FadeTransitionTimeMS,
                yPosition: 0,
            });
        }, 0);
        if (this.shouldAutoDismiss()) {
            this.autoDismissTimerId = window.setTimeout(this.handleTimerElapsed, this.props.autoDismissTimeMS);
        }
    };
    ToastWidget.prototype.componentWillUnmount = function () {
        this.clearTimeouts();
    };
    ToastWidget.prototype.shouldAutoDismiss = function () {
        if (this.props.toastType === ToastType.Error || this.props.toastType === ToastType.Warning ||
            this.props.actionMessage || this.props.onAction) {
            return false;
        }
        return this.props.autoDismiss;
    };
    ToastWidget.prototype.renderActionLink = function () {
        if (!this.props.actionMessage || this.props.actionMessage.length === 0) {
            return null;
        }
        return (React.createElement(TextLinkWidget_1.TextLinkWidget, { className: actionLinkStyleOverrideClass, href: this.props.actionHref, kind: TextLinkWidget_1.TextLinkKind.LowEmphasis, onClick: this.handleClick, style: toastStyles.actionLink, testId: this.props.testId }, this.props.actionMessage));
    };
    ToastWidget.prototype.fadeStyle = function () {
        return {
            opacity: this.state.fadeOpacity,
            transform: "translateY(" + this.state.yPosition + "px)",
            transitionDuration: this.state.fadeTransitionTime + "ms, " + (this.state.fadeTransitionTime + 100) + "ms",
            transitionTimingFunction: 'ease-out',
        };
    };
    ToastWidget.prototype.clearTimeouts = function () {
        clearTimeout(this.autoDismissTimerId);
        clearTimeout(this.fadeOutTimerId);
    };
    ToastWidget.prototype.render = function () {
        var toastStyle = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ left: this.props.topLeftXPx, top: this.props.topLeftYPx }, toastStyles.toastDiv), toastBackgroundColors[this.props.toastType]), this.fadeStyle());
        var toastAttributes = {
            'data-tb-test-id': Declarative_1.testId(this.props.testId, ToastWidget.ToastDivId),
            onMouseOver: this.handleMouseOver,
            onMouseOut: this.handleMouseOut,
        };
        var contentProps = {
            'data-tb-test-id': Declarative_1.testId(this.props.testId, ToastWidget.ToastContentId),
        };
        var messageProps = {
            'data-tb-test-id': Declarative_1.testId(this.props.testId, ToastWidget.ToastMessageId),
        };
        var stackingComponentProps = {
            stackingRootId: this.props.stackingRootId,
            wrapperTestId: this.props.testId,
            zIndex: this.props.zIndex
        };
        var positioningStyle = tslib_1.__assign(tslib_1.__assign({}, toastStyles.positioningDiv), Declarative_1.conditional(!!this.props.topLeftXPx, { justifyContent: undefined }));
        var centeringStyle = {
            maxWidth: exports.ToastMaxWidth
        };
        var prefix = prefixForToastType(this.props.toastType);
        return (React.createElement(StackingComponent_1.StackingComponentWrapper, tslib_1.__assign({}, stackingComponentProps),
            React.createElement("div", { style: positioningStyle },
                React.createElement("div", { style: centeringStyle },
                    React.createElement("div", tslib_1.__assign({ style: toastStyle }, toastAttributes),
                        React.createElement("div", tslib_1.__assign({ style: toastStyles.contentDiv }, contentProps),
                            prefix,
                            React.createElement("div", { style: toastStyles.messageContainer },
                                React.createElement("div", tslib_1.__assign({ style: toastStyles.message, role: 'alert' }, messageProps),
                                    React.createElement("span", { style: { position: 'absolute', color: 'transparent' } }, prefix),
                                    this.props.message,
                                    this.props.children),
                                React.createElement("div", { style: toastStyles.actionContainer }, this.renderActionLink()))),
                        this.renderCloseButton())))));
    };
    ToastWidget.ToastDivId = 'toast-widget';
    ToastWidget.ToastContentId = 'toast-content';
    ToastWidget.ToastMessageId = 'toast-message';
    ToastWidget.FadeTransitionTimeMS = 300;
    ToastWidget.AutodimissCloseFadeTransitionTimeMS = 1000;
    ToastWidget.HoverRestoreFadeTransitionTimeMS = 30;
    ToastWidget.DefaultAutoDissmissTimeMS = 5000;
    ToastWidget.defaultProps = {
        actionHref: 'javascript:void(0)',
        autoDismiss: true,
        autoDismissTimeMS: ToastWidget.DefaultAutoDissmissTimeMS,
    };
    return ToastWidget;
}(React.Component));
exports.ToastWidget = ToastWidget;
//# sourceMappingURL=ToastWidget.js.map